export default "__VITE_ASSET__50ecac8c__"